/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AddEditFallbackPageComponent } from './addEdit/addEditFallbackPage.component';
import { AuthGuard } from '../../../../../core/guards';
import { CertsApiService, FallbackPagesApiService } from '../../../shared/http';
import { FallbackPagesComponent } from './fallbackPages.component';
import { FallbackPagesResolver, SSLCertificateResolver } from '../../../shared/resolvers';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { NgModule } from '@angular/core';

/**
 *
 */
@NgModule({
    imports: [
        LoadbalancerSharedModule
    ],
    declarations: [
        FallbackPagesComponent,
        AddEditFallbackPageComponent
    ],
    providers: [
        AuthGuard,
        FallbackPagesResolver,
        FallbackPagesApiService,
        SSLCertificateResolver,
        CertsApiService
    ]
})

export class FallbackPagesModule {
}
